export default {
  drawer: true,
  color: 'success',
  parent: false
}



// WEBPACK FOOTER //
// ./src/store/modules/app/state.js